/*jshint esversion:6*/
import React from "react";
import Select from "react-select";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Constants from "../../../configurations/constants";
import Permissions from "../../../configurations/permissions";
import ArbiterApi from "../../../api/ArbiterApi";
import SettlementRulesTable from "./settlementRulesTable";
import SettlementRulesModal from "./settlementRulesModal";

class SettlementRulesPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      settlementRules: [],
      selectedSettlementRule: null,
      transactionTypes: [],
      transactionType: null,
      settlementType: null,
      totalCount: 0,
      loading: false,
      pages: 0,
      openModalFlag: false,
      createFlag: false,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pageNum: 0 //Zero based index
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.onNewButtonClick = this.onNewButtonClick.bind(this);
    this.handleTransTypeFilterChange = this.handleTransTypeFilterChange.bind(
      this
    );
    this.handleSettlementTypeFilterChange = this.handleSettlementTypeFilterChange.bind(
      this
    );
    this.paginateid = this.paginateid.bind(this);
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  componentDidMount() {
    //Get Transaction Types
    ArbiterApi.getTransactionTypes()
      .then(response => {
        let transactionTypes = response.data.content.map(obj => {
          obj.label = obj.name;
          obj.value = obj.name;
          return obj;
        });

        this.setState({ transactionTypes });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_TRANSACTION_TYPES}`,
          ""
        ]);
        console.log(error);
      });

    //Load data on mount
    this.reloadTimelines();
  }

  onNewButtonClick(evt) {
    this.setState({ openModalFlag: true, createFlag: true });
  }

  handleTransTypeFilterChange(evt) {
    this.setState(
      {
        transactionType: evt,
        pageNum: 0
      },
      () => this.reloadTimelines()
    );
  }

  handleSettlementTypeFilterChange(evt) {
    this.setState(
      {
        settlementType: evt,
        pageNum: 0
      },
      () => this.reloadTimelines()
    );
  }

  render() {
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Settlement Rules" />
        <Divider />
        <div className="mini-filter">
          <div className="right">
            <br />
            <button
              onClick={this.onNewButtonClick}
              className="btn btn-primary right"
            >
              + New Settlement Rule
            </button>
          </div>

          <div className="filter-select">
            <label className="input-control-label">Transaction Type</label>
            <Select
              placeholder="Transaction Type"
              onChange={this.handleTransTypeFilterChange}
              options={this.state.transactionTypes}
              value={this.state.transactionType}
            />
          </div>

          <div className="filter-select">
            <label className="input-control-label">Settlement Type</label>
            <Select
              placeholder="Settlement Type"
              onChange={this.handleSettlementTypeFilterChange}
              options={Constants.SETTLEMENT_TYPES}
              value={this.state.settlementType}
            />
          </div>
        </div>

        <SettlementRulesTable
          onRowClick={this.onRowClick}
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          settlementRules={this.state.settlementRules}
          paginatedCallBack={this.paginateid}
        />
        {this.state.openModalFlag && (
          <SettlementRulesModal
            isNew={this.state.createFlag}
            isOpen={this.state.openModalFlag}
            onRequestClose={this.handleCloseModal}
            settlementRule={this.state.selectedSettlementRule}
          />
        )}
      </div>
    );
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.loadTimelines(params);
    }
  }

  loadTimelines(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;

    let transactionType = this.state.transactionType;

    if (transactionType && transactionType.value) {
      params.transactionType = transactionType.value;
    }

    let settlementType = this.state.settlementType;

    if (settlementType && settlementType.value) {
      params.settlementType = settlementType.value;
    }

    ArbiterApi.getSettlementRules(params)
      .then(response => {
        let data = response.data.content;
        let totalCount = response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0)
          Toaster.warning("No records found.", "Settlement Rules");
        this.setState({
          settlementRules: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages
        });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_SETTLEMENT_RULES}`
        ]);
        this.setState({ loading: false });
      });
  }

  onRowClick(index) {
    this.setState({
      selectedSettlementRule: this.state.settlementRules[index],
      openModalFlag: true,
      createFlag: false
    });
  }
  handleCloseModal(event, reloadDataFlag) {
    this.setState({
      selectedSettlementRule: null,
      openModalFlag: false,
      createFlag: false
    });
    if (reloadDataFlag) {
      this.reloadTimelines();
    }
  }

  reloadTimelines() {
    this.setState({ settlementRules: [] });
    this.loadTimelines({ pageSize: this.state.pageSize });
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(SettlementRulesPage, [Permissions.VIEW_SETTLEMENT_RULE])
);



// WEBPACK FOOTER //
// ./src/components/settlement/settlementRules/settlementRulesPage.js